import { graphql } from 'react-relay';

export const tradeDesignManagerOnboardingQuery = graphql`
    query tradeDesignManagerOnboardingQuery($userId: String!) {
        viewer {
            user(userId: $userId) {
                isVerifiedTrade
                tradeFirmDesignManagerProfile {
                    hasAccount
                }
            }
        }
    }
`;
